"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _request = _interopRequireDefault(require("./request"));

var _response = _interopRequireDefault(require("./response"));

var _package = _interopRequireDefault(require("../package.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _awaitAsyncGenerator(value) { return new _AwaitValue(value); }

function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }

function _AsyncGenerator(gen) { var front, back; function send(key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; if (back) { back = back.next = request; } else { front = back = request; resume(key, arg); } }); } function resume(key, arg) { try { var result = gen[key](arg); var value = result.value; var wrappedAwait = value instanceof _AwaitValue; Promise.resolve(wrappedAwait ? value.wrapped : value).then(function (arg) { if (wrappedAwait) { resume("next", arg); return; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: true }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: false }); break; } front = front.next; if (front) { resume(front.key, front.arg); } else { back = null; } } this._invoke = send; if (typeof gen["return"] !== "function") { this["return"] = undefined; } }

if (typeof Symbol === "function" && Symbol.asyncIterator) { _AsyncGenerator.prototype[Symbol.asyncIterator] = function () { return this; }; }

_AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); };

_AsyncGenerator.prototype["throw"] = function (arg) { return this._invoke("throw", arg); };

_AsyncGenerator.prototype["return"] = function (arg) { return this._invoke("return", arg); };

function _AwaitValue(value) { this.wrapped = value; }

var APIClient =
/*#__PURE__*/
function () {
  function APIClient() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        baseURL = _ref.baseURL,
        token = _ref.token,
        consumerName = _ref.consumerName,
        consumerVersion = _ref.consumerVersion,
        systemName = _ref.systemName,
        systemVersion = _ref.systemVersion;

    _classCallCheck(this, APIClient);

    var clientId = "".concat(_package["default"].name, " ").concat(_package["default"].version);
    var consumerId = "".concat(consumerName || '', " ").concat(consumerVersion || '');
    var systemId = "".concat(systemName || '', " ").concat(systemVersion || '');
    this.baseURL = baseURL;
    this.token = token;
    this.userAgent = "Client-Consumer: ".concat(clientId, "; ").concat(consumerId, "; ").concat(systemId);
  }

  _createClass(APIClient, [{
    key: "_fetch",
    value: function () {
      var _fetch2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(fragment, method, data, urlParams) {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _request["default"])({
                  base: this.baseURL,
                  params: urlParams,
                  token: this.token,
                  userAgent: this.userAgent,
                  fragment: fragment,
                  method: method,
                  data: data
                });

              case 2:
                response = _context.sent;
                _context.next = 5;
                return (0, _response["default"])(response);

              case 5:
                return _context.abrupt("return", _context.sent);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _fetch(_x, _x2, _x3, _x4) {
        return _fetch2.apply(this, arguments);
      }

      return _fetch;
    }()
  }, {
    key: "_nextCursor",
    value: function _nextCursor(page, direction) {
      return direction === 'reverse' ? page.previous : page.next;
    }
  }, {
    key: "_getCursorList",
    value: function _getCursorList(_ref2) {
      var _this = this;

      var cursor = _ref2.cursor,
          _ref2$direction = _ref2.direction,
          direction = _ref2$direction === void 0 ? 'forward' : _ref2$direction,
          urlParams = _objectWithoutProperties(_ref2, ["cursor", "direction"]);

      return _wrapAsyncGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!cursor) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 3;
                return _awaitAsyncGenerator(_this._fetch(cursor, 'GET', undefined, urlParams));

              case 3:
                response = _context2.sent;
                cursor = _this._nextCursor(response, direction);

                if (!cursor) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 8;
                return response;

              case 8:
                _context2.next = 0;
                break;

              case 10:
                return _context2.abrupt("return", response);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }, {
    key: "getUserData",
    value: function getUserData() {
      return this._fetch('users/me/', 'GET');
    }
  }, {
    key: "deleteUser",
    value: function deleteUser() {
      return this._fetch('users/me/', 'DELETE');
    }
  }, {
    key: "patchUserData",
    value: function patchUserData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this._fetch('users/me/', 'PATCH', data);
    }
  }, {
    key: "getDevices",
    value: function getDevices() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$cursor = _ref3.cursor,
          cursor = _ref3$cursor === void 0 ? 'devices/' : _ref3$cursor,
          _ref3$direction = _ref3.direction,
          direction = _ref3$direction === void 0 ? 'forward' : _ref3$direction,
          urlParams = _objectWithoutProperties(_ref3, ["cursor", "direction"]);

      return this._getCursorList(_objectSpread({
        cursor: cursor,
        direction: direction
      }, urlParams));
    }
  }, {
    key: "registerDevice",
    value: function registerDevice() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this._fetch('devices/', 'POST', data);
    }
  }, {
    key: "pingDevices",
    value: function pingDevices() {
      return this._fetch('devices/ping/', 'POST');
    }
  }, {
    key: "getLinkConfig",
    value: function getLinkConfig() {
      return this._fetch('banks/link_config/', 'GET');
    }
  }, {
    key: "jwtLogin",
    value: function jwtLogin(username, password) {
      return this._fetch('token/', 'POST', {
        username: username,
        password: password
      });
    }
  }, {
    key: "jwtRefresh",
    value: function jwtRefresh(token) {
      return this._fetch('token/refresh/', 'POST', {
        token: token
      });
    }
  }, {
    key: "loginWithGoogleAuthCode",
    value: function loginWithGoogleAuthCode(code) {
      var disable_integration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return this._fetch('users/login_with_google_code/', 'POST', {
        code: code,
        disable_integration: disable_integration
      });
    }
  }, {
    key: "proxyUser",
    value: function proxyUser(username) {
      return this._fetch('users/proxy/', 'POST', {
        username: username
      });
    }
  }, {
    key: "logout",
    value: function logout() {
      return this._fetch('users/logout/', 'POST');
    }
  }, {
    key: "getBanks",
    value: function getBanks() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$cursor = _ref4.cursor,
          cursor = _ref4$cursor === void 0 ? 'banks/' : _ref4$cursor,
          _ref4$direction = _ref4.direction,
          direction = _ref4$direction === void 0 ? 'forward' : _ref4$direction,
          urlParams = _objectWithoutProperties(_ref4, ["cursor", "direction"]);

      return this._getCursorList(_objectSpread({
        cursor: cursor,
        direction: direction
      }, urlParams));
    }
  }, {
    key: "getBank",
    value: function getBank(_ref5) {
      var id = _ref5.id,
          _ref5$bank = _ref5.bank,
          bank = _ref5$bank === void 0 ? {} : _ref5$bank;
      var url = bank.url;
      url = url || "banks/".concat(id, "/");
      return this._fetch(url, 'GET');
    }
  }, {
    key: "createBank",
    value: function createBank(public_token) {
      return this._fetch('banks/', 'POST', {
        public_token: public_token
      });
    }
  }, {
    key: "createBankPublicToken",
    value: function createBankPublicToken(_ref6) {
      var id = _ref6.id,
          _ref6$bank = _ref6.bank,
          bank = _ref6$bank === void 0 ? {} : _ref6$bank;
      var url = bank.url;
      url = url || "banks/".concat(id, "/");
      url = "".concat(url, "create_public_token/");
      return this._fetch(url, 'POST');
    }
  }, {
    key: "getAccounts",
    value: function getAccounts() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref7$cursor = _ref7.cursor,
          cursor = _ref7$cursor === void 0 ? 'accounts/' : _ref7$cursor,
          _ref7$direction = _ref7.direction,
          direction = _ref7$direction === void 0 ? 'forward' : _ref7$direction,
          urlParams = _objectWithoutProperties(_ref7, ["cursor", "direction"]);

      return this._getCursorList(_objectSpread({
        cursor: cursor,
        direction: direction
      }, urlParams));
    }
  }, {
    key: "getAccount",
    value: function getAccount(_ref8) {
      var id = _ref8.id,
          _ref8$account = _ref8.account,
          account = _ref8$account === void 0 ? {} : _ref8$account;
      var url = account.url;
      url = url || "accounts/".concat(id, "/");
      return this._fetch(url, 'GET');
    }
  }, {
    key: "enableAccount",
    value: function enableAccount() {
      var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref9.id,
          _ref9$account = _ref9.account,
          account = _ref9$account === void 0 ? {} : _ref9$account;

      var url = account.url;
      url = url || "accounts/".concat(id, "/");
      url = "".concat(url, "enable/");
      return this._fetch(url, 'POST');
    }
  }, {
    key: "disableAccount",
    value: function disableAccount() {
      var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref10.id,
          _ref10$account = _ref10.account,
          account = _ref10$account === void 0 ? {} : _ref10$account;

      var url = account.url;
      url = url || "accounts/".concat(id, "/");
      url = "".concat(url, "disable/");
      return this._fetch(url, 'POST');
    }
  }, {
    key: "getHealthFactors",
    value: function getHealthFactors() {
      var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref11$cursor = _ref11.cursor,
          cursor = _ref11$cursor === void 0 ? 'health_factors/' : _ref11$cursor,
          _ref11$direction = _ref11.direction,
          direction = _ref11$direction === void 0 ? 'forward' : _ref11$direction,
          urlParams = _objectWithoutProperties(_ref11, ["cursor", "direction"]);

      return this._getCursorList(_objectSpread({
        cursor: cursor,
        direction: direction
      }, urlParams));
    }
  }, {
    key: "aggregateHealthFactors",
    value: function aggregateHealthFactors() {
      var urlParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var url = 'health_factors/aggregate/';
      return this._fetch(url, 'GET', undefined, urlParams);
    }
  }, {
    key: "enableHealthFactor",
    value: function enableHealthFactor() {
      var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref12.id,
          _ref12$healthFactor = _ref12.healthFactor,
          healthFactor = _ref12$healthFactor === void 0 ? {} : _ref12$healthFactor;

      var url = healthFactor.url;
      url = url || "health_factors/".concat(id, "/");
      url = "".concat(url, "enable/");
      return this._fetch(url, 'POST');
    }
  }, {
    key: "disableHealthFactor",
    value: function disableHealthFactor() {
      var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref13.id,
          _ref13$healthFactor = _ref13.healthFactor,
          healthFactor = _ref13$healthFactor === void 0 ? {} : _ref13$healthFactor;

      var url = healthFactor.url;
      url = url || "health_factors/".concat(id, "/");
      url = "".concat(url, "disable/");
      return this._fetch(url, 'POST');
    }
  }, {
    key: "createHealthFactor",
    value: function createHealthFactor(factor) {
      return this._fetch('health_factors/', 'POST', factor);
    }
  }, {
    key: "updateHealthFactor",
    value: function updateHealthFactor(factor) {
      return this._fetch("health_factors/".concat(factor.id, "/"), 'PUT', factor);
    }
  }, {
    key: "patchHealthFactor",
    value: function patchHealthFactor(factor) {
      return this._fetch("health_factors/".concat(factor.id, "/"), 'PATCH', factor);
    }
  }, {
    key: "getSocialAuths",
    value: function getSocialAuths() {
      var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref14$cursor = _ref14.cursor,
          cursor = _ref14$cursor === void 0 ? 'social-auths/' : _ref14$cursor,
          _ref14$direction = _ref14.direction,
          direction = _ref14$direction === void 0 ? 'forward' : _ref14$direction,
          urlParams = _objectWithoutProperties(_ref14, ["cursor", "direction"]);

      return this._getCursorList(_objectSpread({
        cursor: cursor,
        direction: direction
      }, urlParams));
    }
  }, {
    key: "getIntegrations",
    value: function getIntegrations() {
      var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref15$cursor = _ref15.cursor,
          cursor = _ref15$cursor === void 0 ? 'integrations/' : _ref15$cursor,
          _ref15$direction = _ref15.direction,
          direction = _ref15$direction === void 0 ? 'forward' : _ref15$direction,
          urlParams = _objectWithoutProperties(_ref15, ["cursor", "direction"]);

      return this._getCursorList(_objectSpread({
        cursor: cursor,
        direction: direction
      }, urlParams));
    }
  }, {
    key: "getIntegration",
    value: function getIntegration() {
      var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref16.id,
          _ref16$integration = _ref16.integration,
          integration = _ref16$integration === void 0 ? {} : _ref16$integration;

      var url = integration.url;
      url = url || "integrations/".concat(id, "/");
      return this._fetch(url, 'GET');
    }
  }, {
    key: "updateIntegrationData",
    value: function updateIntegrationData() {
      var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref17.id,
          _ref17$integration = _ref17.integration,
          integration = _ref17$integration === void 0 ? {} : _ref17$integration;

      var url = integration.url;
      url = url || "integrations/".concat(id, "/");
      url = "".concat(url, "update_data/");
      return this._fetch(url, 'POST');
    }
  }, {
    key: "disableIntegration",
    value: function disableIntegration() {
      var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref18.id,
          _ref18$integration = _ref18.integration,
          integration = _ref18$integration === void 0 ? {} : _ref18$integration;

      var url = integration.url;
      url = url || "integrations/".concat(id, "/");
      url = "".concat(url, "disable/");
      return this._fetch(url, 'POST');
    }
  }, {
    key: "enableIntegration",
    value: function enableIntegration() {
      var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref19.id,
          _ref19$integration = _ref19.integration,
          integration = _ref19$integration === void 0 ? {} : _ref19$integration;

      var url = integration.url;
      url = url || "integrations/".concat(id, "/");
      url = "".concat(url, "enable/");
      return this._fetch(url, 'POST');
    }
  }, {
    key: "deleteIntegrationFactors",
    value: function deleteIntegrationFactors() {
      var _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref20.id,
          _ref20$integration = _ref20.integration,
          integration = _ref20$integration === void 0 ? {} : _ref20$integration;

      var url = integration.url;
      url = url || "integrations/".concat(id, "/");
      url = "".concat(url, "delete_factors/");
      return this._fetch(url, 'POST');
    }
  }, {
    key: "deleteIntegration",
    value: function deleteIntegration() {
      var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref21.id,
          _ref21$integration = _ref21.integration,
          integration = _ref21$integration === void 0 ? {} : _ref21$integration;

      var url = integration.url;
      url = url || "integrations/".concat(id, "/");
      return this._fetch(url, 'DELETE');
    }
  }, {
    key: "getPlace",
    value: function getPlace() {
      var _ref22 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref22.id,
          _ref22$place = _ref22.place,
          place = _ref22$place === void 0 ? {} : _ref22$place;

      var url = place.url;
      url = url || "places/".concat(id, "/");
      return this._fetch(url, 'GET');
    }
  }, {
    key: "getPlaces",
    value: function getPlaces() {
      var _ref23 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref23$cursor = _ref23.cursor,
          cursor = _ref23$cursor === void 0 ? 'places/' : _ref23$cursor,
          _ref23$direction = _ref23.direction,
          direction = _ref23$direction === void 0 ? 'forward' : _ref23$direction,
          urlParams = _objectWithoutProperties(_ref23, ["cursor", "direction"]);

      return this._getCursorList(_objectSpread({
        cursor: cursor,
        direction: direction
      }, urlParams));
    }
  }, {
    key: "getGooglePlace",
    value: function getGooglePlace() {
      var _ref24 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref24.id,
          _ref24$place = _ref24.place,
          place = _ref24$place === void 0 ? {} : _ref24$place;

      var url = place.url;
      url = url || "googleplaces/".concat(id, "/");
      return this._fetch(url, 'GET');
    }
  }, {
    key: "getGooglePlaces",
    value: function getGooglePlaces() {
      var _ref25 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref25$cursor = _ref25.cursor,
          cursor = _ref25$cursor === void 0 ? 'googleplaces/' : _ref25$cursor,
          _ref25$direction = _ref25.direction,
          direction = _ref25$direction === void 0 ? 'forward' : _ref25$direction,
          urlParams = _objectWithoutProperties(_ref25, ["cursor", "direction"]);

      return this._getCursorList(_objectSpread({
        cursor: cursor,
        direction: direction
      }, urlParams));
    }
  }, {
    key: "createWithingsAuthURL",
    value: function createWithingsAuthURL() {
      return this._fetch('withings/generate_auth_url/', 'POST');
    }
  }, {
    key: "exchangeWithingsAuthCode",
    value: function exchangeWithingsAuthCode(callbackPayload) {
      return this._fetch('withings/exchange_auth_code/', 'POST', callbackPayload);
    }
  }, {
    key: "login",
    value: function login(email, password) {
      return this._fetch('users/login/', 'POST', {
        email: email,
        password: password
      });
    }
  }, {
    key: "sendEmailAuthLink",
    value: function sendEmailAuthLink(authRequest) {
      return this._fetch('email_auth/', 'POST', authRequest);
    }
  }, {
    key: "exchangeEmailAuthCode",
    value: function exchangeEmailAuthCode(email_auth_token) {
      return this._fetch('email_auth/exchange/', 'POST', {
        email_auth_token: email_auth_token
      });
    }
  }, {
    key: "sendChangeUsernameConfirmation",
    value: function sendChangeUsernameConfirmation(authRequest) {
      return this._fetch('change_username/', 'POST', authRequest);
    }
  }, {
    key: "exchangeChangeUsernameToken",
    value: function exchangeChangeUsernameToken(email_auth_token) {
      return this._fetch('change_username/exchange/', 'POST', {
        email_auth_token: email_auth_token
      });
    }
  }, {
    key: "sendPasswordResetLink",
    value: function sendPasswordResetLink(authRequest) {
      return this._fetch('password_reset/', 'POST', authRequest);
    }
  }, {
    key: "exchangePasswordResetCode",
    value: function exchangePasswordResetCode(email_auth_token, new_password) {
      return this._fetch('password_reset/exchange/', 'POST', {
        email_auth_token: email_auth_token,
        new_password: new_password
      });
    }
  }, {
    key: "changePassword",
    value: function changePassword(password, new_password) {
      return this._fetch('users/change_password/', 'POST', {
        password: password,
        new_password: new_password
      });
    }
  }, {
    key: "enableHealthkit",
    value: function enableHealthkit() {
      return this._fetch('healthkit/', 'POST');
    }
  }, {
    key: "bulkHealthkitSampleCreateOrUpdate",
    value: function bulkHealthkitSampleCreateOrUpdate(samples) {
      return this._fetch('healthkit_samples/bulk_create_or_update/', 'POST', samples);
    }
  }, {
    key: "bulkHealthkitSampleDelete",
    value: function bulkHealthkitSampleDelete(samples) {
      return this._fetch('healthkit_samples/bulk_delete/', 'POST', samples);
    }
  }]);

  return APIClient;
}();

exports["default"] = APIClient;